module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2015-08-04",
		"endpointPrefix": "firehose",
		"jsonVersion": "1.1",
		"protocol": "json",
		"serviceAbbreviation": "Firehose",
		"serviceFullName": "Amazon Kinesis Firehose",
		"signatureVersion": "v4",
		"targetPrefix": "Firehose_20150804",
		"uid": "firehose-2015-08-04"
	},
	"operations": {
		"CreateDeliveryStream": {
			"input": {
				"type": "structure",
				"required": [
					"DeliveryStreamName"
				],
				"members": {
					"DeliveryStreamName": {},
					"DeliveryStreamType": {},
					"KinesisStreamSourceConfiguration": {
						"type": "structure",
						"required": [
							"KinesisStreamARN",
							"RoleARN"
						],
						"members": {
							"KinesisStreamARN": {},
							"RoleARN": {}
						}
					},
					"S3DestinationConfiguration": {
						"shape": "S7",
						"deprecated": true
					},
					"ExtendedS3DestinationConfiguration": {
						"type": "structure",
						"required": [
							"RoleARN",
							"BucketARN"
						],
						"members": {
							"RoleARN": {},
							"BucketARN": {},
							"Prefix": {},
							"BufferingHints": {
								"shape": "Sa"
							},
							"CompressionFormat": {},
							"EncryptionConfiguration": {
								"shape": "Se"
							},
							"CloudWatchLoggingOptions": {
								"shape": "Si"
							},
							"ProcessingConfiguration": {
								"shape": "Sn"
							},
							"S3BackupMode": {},
							"S3BackupConfiguration": {
								"shape": "S7"
							}
						}
					},
					"RedshiftDestinationConfiguration": {
						"type": "structure",
						"required": [
							"RoleARN",
							"ClusterJDBCURL",
							"CopyCommand",
							"Username",
							"Password",
							"S3Configuration"
						],
						"members": {
							"RoleARN": {},
							"ClusterJDBCURL": {},
							"CopyCommand": {
								"shape": "Sy"
							},
							"Username": {
								"shape": "S12"
							},
							"Password": {
								"shape": "S13"
							},
							"RetryOptions": {
								"shape": "S14"
							},
							"S3Configuration": {
								"shape": "S7"
							},
							"ProcessingConfiguration": {
								"shape": "Sn"
							},
							"S3BackupMode": {},
							"S3BackupConfiguration": {
								"shape": "S7"
							},
							"CloudWatchLoggingOptions": {
								"shape": "Si"
							}
						}
					},
					"ElasticsearchDestinationConfiguration": {
						"type": "structure",
						"required": [
							"RoleARN",
							"DomainARN",
							"IndexName",
							"TypeName",
							"S3Configuration"
						],
						"members": {
							"RoleARN": {},
							"DomainARN": {},
							"IndexName": {},
							"TypeName": {},
							"IndexRotationPeriod": {},
							"BufferingHints": {
								"shape": "S1c"
							},
							"RetryOptions": {
								"shape": "S1f"
							},
							"S3BackupMode": {},
							"S3Configuration": {
								"shape": "S7"
							},
							"ProcessingConfiguration": {
								"shape": "Sn"
							},
							"CloudWatchLoggingOptions": {
								"shape": "Si"
							}
						}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"DeliveryStreamARN": {}
				}
			}
		},
		"DeleteDeliveryStream": {
			"input": {
				"type": "structure",
				"required": [
					"DeliveryStreamName"
				],
				"members": {
					"DeliveryStreamName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DescribeDeliveryStream": {
			"input": {
				"type": "structure",
				"required": [
					"DeliveryStreamName"
				],
				"members": {
					"DeliveryStreamName": {},
					"Limit": {
						"type": "integer"
					},
					"ExclusiveStartDestinationId": {}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"DeliveryStreamDescription"
				],
				"members": {
					"DeliveryStreamDescription": {
						"type": "structure",
						"required": [
							"DeliveryStreamName",
							"DeliveryStreamARN",
							"DeliveryStreamStatus",
							"DeliveryStreamType",
							"VersionId",
							"Destinations",
							"HasMoreDestinations"
						],
						"members": {
							"DeliveryStreamName": {},
							"DeliveryStreamARN": {},
							"DeliveryStreamStatus": {},
							"DeliveryStreamType": {},
							"VersionId": {},
							"CreateTimestamp": {
								"type": "timestamp"
							},
							"LastUpdateTimestamp": {
								"type": "timestamp"
							},
							"Source": {
								"type": "structure",
								"members": {
									"KinesisStreamSourceDescription": {
										"type": "structure",
										"members": {
											"KinesisStreamARN": {},
											"RoleARN": {},
											"DeliveryStartTimestamp": {
												"type": "timestamp"
											}
										}
									}
								}
							},
							"Destinations": {
								"type": "list",
								"member": {
									"type": "structure",
									"required": [
										"DestinationId"
									],
									"members": {
										"DestinationId": {},
										"S3DestinationDescription": {
											"shape": "S1z"
										},
										"ExtendedS3DestinationDescription": {
											"type": "structure",
											"required": [
												"RoleARN",
												"BucketARN",
												"BufferingHints",
												"CompressionFormat",
												"EncryptionConfiguration"
											],
											"members": {
												"RoleARN": {},
												"BucketARN": {},
												"Prefix": {},
												"BufferingHints": {
													"shape": "Sa"
												},
												"CompressionFormat": {},
												"EncryptionConfiguration": {
													"shape": "Se"
												},
												"CloudWatchLoggingOptions": {
													"shape": "Si"
												},
												"ProcessingConfiguration": {
													"shape": "Sn"
												},
												"S3BackupMode": {},
												"S3BackupDescription": {
													"shape": "S1z"
												}
											}
										},
										"RedshiftDestinationDescription": {
											"type": "structure",
											"required": [
												"RoleARN",
												"ClusterJDBCURL",
												"CopyCommand",
												"Username",
												"S3DestinationDescription"
											],
											"members": {
												"RoleARN": {},
												"ClusterJDBCURL": {},
												"CopyCommand": {
													"shape": "Sy"
												},
												"Username": {
													"shape": "S12"
												},
												"RetryOptions": {
													"shape": "S14"
												},
												"S3DestinationDescription": {
													"shape": "S1z"
												},
												"ProcessingConfiguration": {
													"shape": "Sn"
												},
												"S3BackupMode": {},
												"S3BackupDescription": {
													"shape": "S1z"
												},
												"CloudWatchLoggingOptions": {
													"shape": "Si"
												}
											}
										},
										"ElasticsearchDestinationDescription": {
											"type": "structure",
											"members": {
												"RoleARN": {},
												"DomainARN": {},
												"IndexName": {},
												"TypeName": {},
												"IndexRotationPeriod": {},
												"BufferingHints": {
													"shape": "S1c"
												},
												"RetryOptions": {
													"shape": "S1f"
												},
												"S3BackupMode": {},
												"S3DestinationDescription": {
													"shape": "S1z"
												},
												"ProcessingConfiguration": {
													"shape": "Sn"
												},
												"CloudWatchLoggingOptions": {
													"shape": "Si"
												}
											}
										}
									}
								}
							},
							"HasMoreDestinations": {
								"type": "boolean"
							}
						}
					}
				}
			}
		},
		"GetKinesisStream": {
			"input": {
				"type": "structure",
				"required": [
					"DeliveryStreamARN"
				],
				"members": {
					"DeliveryStreamARN": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"KinesisStreamARN": {},
					"CredentialsForReadingKinesisStream": {
						"type": "structure",
						"required": [
							"AccessKeyId",
							"SecretAccessKey",
							"SessionToken",
							"Expiration"
						],
						"members": {
							"AccessKeyId": {},
							"SecretAccessKey": {},
							"SessionToken": {},
							"Expiration": {
								"type": "timestamp"
							}
						}
					}
				}
			},
			"internalonly": true
		},
		"ListDeliveryStreams": {
			"input": {
				"type": "structure",
				"members": {
					"Limit": {
						"type": "integer"
					},
					"DeliveryStreamType": {},
					"ExclusiveStartDeliveryStreamName": {}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"DeliveryStreamNames",
					"HasMoreDeliveryStreams"
				],
				"members": {
					"DeliveryStreamNames": {
						"type": "list",
						"member": {}
					},
					"HasMoreDeliveryStreams": {
						"type": "boolean"
					}
				}
			}
		},
		"PutRecord": {
			"input": {
				"type": "structure",
				"required": [
					"DeliveryStreamName",
					"Record"
				],
				"members": {
					"DeliveryStreamName": {},
					"Record": {
						"shape": "S2e"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"RecordId"
				],
				"members": {
					"RecordId": {}
				}
			}
		},
		"PutRecordBatch": {
			"input": {
				"type": "structure",
				"required": [
					"DeliveryStreamName",
					"Records"
				],
				"members": {
					"DeliveryStreamName": {},
					"Records": {
						"type": "list",
						"member": {
							"shape": "S2e"
						}
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"FailedPutCount",
					"RequestResponses"
				],
				"members": {
					"FailedPutCount": {
						"type": "integer"
					},
					"RequestResponses": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"RecordId": {},
								"ErrorCode": {},
								"ErrorMessage": {}
							}
						}
					}
				}
			}
		},
		"UpdateDestination": {
			"input": {
				"type": "structure",
				"required": [
					"DeliveryStreamName",
					"CurrentDeliveryStreamVersionId",
					"DestinationId"
				],
				"members": {
					"DeliveryStreamName": {},
					"CurrentDeliveryStreamVersionId": {},
					"DestinationId": {},
					"S3DestinationUpdate": {
						"shape": "S2r",
						"deprecated": true
					},
					"ExtendedS3DestinationUpdate": {
						"type": "structure",
						"members": {
							"RoleARN": {},
							"BucketARN": {},
							"Prefix": {},
							"BufferingHints": {
								"shape": "Sa"
							},
							"CompressionFormat": {},
							"EncryptionConfiguration": {
								"shape": "Se"
							},
							"CloudWatchLoggingOptions": {
								"shape": "Si"
							},
							"ProcessingConfiguration": {
								"shape": "Sn"
							},
							"S3BackupMode": {},
							"S3BackupUpdate": {
								"shape": "S2r"
							}
						}
					},
					"RedshiftDestinationUpdate": {
						"type": "structure",
						"members": {
							"RoleARN": {},
							"ClusterJDBCURL": {},
							"CopyCommand": {
								"shape": "Sy"
							},
							"Username": {
								"shape": "S12"
							},
							"Password": {
								"shape": "S13"
							},
							"RetryOptions": {
								"shape": "S14"
							},
							"S3Update": {
								"shape": "S2r"
							},
							"ProcessingConfiguration": {
								"shape": "Sn"
							},
							"S3BackupMode": {},
							"S3BackupUpdate": {
								"shape": "S2r"
							},
							"CloudWatchLoggingOptions": {
								"shape": "Si"
							}
						}
					},
					"ElasticsearchDestinationUpdate": {
						"type": "structure",
						"members": {
							"RoleARN": {},
							"DomainARN": {},
							"IndexName": {},
							"TypeName": {},
							"IndexRotationPeriod": {},
							"BufferingHints": {
								"shape": "S1c"
							},
							"RetryOptions": {
								"shape": "S1f"
							},
							"S3Update": {
								"shape": "S2r"
							},
							"ProcessingConfiguration": {
								"shape": "Sn"
							},
							"CloudWatchLoggingOptions": {
								"shape": "Si"
							}
						}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		}
	},
	"shapes": {
		"S7": {
			"type": "structure",
			"required": [
				"RoleARN",
				"BucketARN"
			],
			"members": {
				"RoleARN": {},
				"BucketARN": {},
				"Prefix": {},
				"BufferingHints": {
					"shape": "Sa"
				},
				"CompressionFormat": {},
				"EncryptionConfiguration": {
					"shape": "Se"
				},
				"CloudWatchLoggingOptions": {
					"shape": "Si"
				}
			}
		},
		"Sa": {
			"type": "structure",
			"members": {
				"SizeInMBs": {
					"type": "integer"
				},
				"IntervalInSeconds": {
					"type": "integer"
				}
			}
		},
		"Se": {
			"type": "structure",
			"members": {
				"NoEncryptionConfig": {},
				"KMSEncryptionConfig": {
					"type": "structure",
					"required": [
						"AWSKMSKeyARN"
					],
					"members": {
						"AWSKMSKeyARN": {}
					}
				}
			}
		},
		"Si": {
			"type": "structure",
			"members": {
				"Enabled": {
					"type": "boolean"
				},
				"LogGroupName": {},
				"LogStreamName": {}
			}
		},
		"Sn": {
			"type": "structure",
			"members": {
				"Enabled": {
					"type": "boolean"
				},
				"Processors": {
					"type": "list",
					"member": {
						"type": "structure",
						"required": [
							"Type"
						],
						"members": {
							"Type": {},
							"Parameters": {
								"type": "list",
								"member": {
									"type": "structure",
									"required": [
										"ParameterName",
										"ParameterValue"
									],
									"members": {
										"ParameterName": {},
										"ParameterValue": {}
									}
								}
							}
						}
					}
				}
			}
		},
		"Sy": {
			"type": "structure",
			"required": [
				"DataTableName"
			],
			"members": {
				"DataTableName": {},
				"DataTableColumns": {},
				"CopyOptions": {}
			}
		},
		"S12": {
			"type": "string",
			"sensitive": true
		},
		"S13": {
			"type": "string",
			"sensitive": true
		},
		"S14": {
			"type": "structure",
			"members": {
				"DurationInSeconds": {
					"type": "integer"
				}
			}
		},
		"S1c": {
			"type": "structure",
			"members": {
				"IntervalInSeconds": {
					"type": "integer"
				},
				"SizeInMBs": {
					"type": "integer"
				}
			}
		},
		"S1f": {
			"type": "structure",
			"members": {
				"DurationInSeconds": {
					"type": "integer"
				}
			}
		},
		"S1z": {
			"type": "structure",
			"required": [
				"RoleARN",
				"BucketARN",
				"BufferingHints",
				"CompressionFormat",
				"EncryptionConfiguration"
			],
			"members": {
				"RoleARN": {},
				"BucketARN": {},
				"Prefix": {},
				"BufferingHints": {
					"shape": "Sa"
				},
				"CompressionFormat": {},
				"EncryptionConfiguration": {
					"shape": "Se"
				},
				"CloudWatchLoggingOptions": {
					"shape": "Si"
				}
			}
		},
		"S2e": {
			"type": "structure",
			"required": [
				"Data"
			],
			"members": {
				"Data": {
					"type": "blob"
				}
			}
		},
		"S2r": {
			"type": "structure",
			"members": {
				"RoleARN": {},
				"BucketARN": {},
				"Prefix": {},
				"BufferingHints": {
					"shape": "Sa"
				},
				"CompressionFormat": {},
				"EncryptionConfiguration": {
					"shape": "Se"
				},
				"CloudWatchLoggingOptions": {
					"shape": "Si"
				}
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/firehose-2015-08-04.min.json
// module id = 628
// module chunks = 0